import React, { memo, useMemo } from 'react';
import { getSrcCompanyCircleAvatar } from 'utils/getSrcAvatar';
import { Text, Icon, Avatar, Spacer, useTheme } from '@Sage/hoi-poi-ui';

function SortableEntity({ entity, startIndex, index }) {
    const theme = useTheme();
    const { src, fallbackSrc } = useMemo(
        () => getSrcCompanyCircleAvatar(entity.AccountId),
        [entity],
    );
    return (
        <div className="fm-schedule-sorting-map-modal__entity">
            <Icon
                name="locationOff"
                color={theme.colors.grey[500]}
                className="fm-schedule-sorting-map-modal__icon"
            />
            <Text
                className="fm-schedule-sorting-map-modal__entity-index"
                color={theme.colors.utility.textSecondary}
            >
                {index + startIndex + 1}
            </Text>
            <Avatar
                className="fm-schedule-sorting-map-modal__entity-avatar"
                src={src}
                size="small"
                placeholder={fallbackSrc}
            />
            <Spacer x={1} />
            <Text
                className="fm-schedule-sorting-map-modal__entity-name"
                type="subtitle"
                color={theme.colors.utility.textSecondary}
                isTruncated
                useTooltip
            >
                {entity.AccountName}
            </Text>
        </div>
    );
}

export default memo(SortableEntity);
